import { render, staticRenderFns } from "./salesAgents.vue?vue&type=template&id=f661eab4&scoped=true"
import script from "./salesAgents.vue?vue&type=script&lang=js"
export * from "./salesAgents.vue?vue&type=script&lang=js"
import style0 from "./salesAgents.vue?vue&type=style&index=0&id=f661eab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f661eab4",
  null
  
)

export default component.exports